// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"ClosedStore_PageHolder__2PZuE","ImageHolder":"ClosedStore_ImageHolder__AyibV"};